import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faUniversity } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import { ACCOUNT_MESSAGES } from "../messages";

interface MenuItem {
    text: string;
    link: string;
    icon: IconDefinition;
}

const AccountMenu = () => {
    const { lang } = useLanguage();

    // Add new user pages here
    const menu: MenuItem[] = [
        { text: ACCOUNT_MESSAGES.myCourses, link: ROUTES.myCourses(lang), icon: faUniversity }
    ];

    return (
        <nav className="w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100">
            <ul className="list-none">
                {menu.map((item) => (
                    <li
                        key={item.link}
                        className="first:rounded-t-md last:rounded-b-md last:border-b-0 border-b-2 border-gray-200 m-0 transition hover:bg-gray-200"
                    >
                        {/* The link fills the whole row, so the entire row is clickable */}
                        <Link to={item.link} className="flex justify-center items-center p-5">
                            <FontAwesomeIcon icon={item.icon} className="ml-3" size="lg" />
                            <span>{item.text}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default AccountMenu;